<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div
    *ngIf="
      (loading && !internalServerError) ||
      (isWaitingForUpdate && !isType('CHECKOUT') && !internalServerError)
    "
  >
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <div
        class="img-wrapper"
        *ngIf="
          isType('CHECKOUT') ||
            (isType('TOKENIZED_ONBOARDING') && !isWaitingForUpdate) ||
            (isType('TOKENIZED_ONBOARDING_WITH_PAYMENT') &&
              !isWaitingForUpdate);
          else tokenizedOnboardingSuccessImage
        "
      >
        <app-zaver-icon [size]="88" name="diamond"></app-zaver-icon>
      </div>

      <ng-template #tokenizedOnboardingSuccessImage>
        <div class="img-wrapper" *ngIf="!isWaitingForUpdate">
          <app-zaver-icon [size]="88" name="diamond"></app-zaver-icon>
        </div>
      </ng-template>

      <app-de-checkout-success
        *ngIf="isType('CHECKOUT')"
        [amount]="state.totalCheckoutValue"
        [email]="email"
        (onDetailsClick)="toggleModal()"
        [paymentMethodString]="paymentMethodString"
      ></app-de-checkout-success>

      <app-de-precheck-success
        *ngIf="isType('PRECHECK')"
        [amount]="state.totalCheckoutValue"
      ></app-de-precheck-success>

      <app-de-tokenized-onboarding-success
        *ngIf="
          isType('TOKENIZED_ONBOARDING') ||
          isType('TOKENIZED_ONBOARDING_WITH_PAYMENT')
        "
        [params]="state.currentPageInformation.pageSpecificParameters"
        [state]="state"
        [isWaitingForUpdate]="isWaitingForUpdate"
        [hasSuccessRouteFailed]="hasSuccessRouteFailed"
        [email]="email"
        (onDetailsClick)="toggleModal()"
      ></app-de-tokenized-onboarding-success>

      <app-de-collective-invoice-success
        *ngIf="isType('COLLECTIVE_INVOICE')"
        [params]="state.currentPageInformation.pageSpecificParameters"
        (onDetailsClick)="toggleModal()"
        [email]="email"
        [totalCheckoutValue]="totalCheckoutValue"
        [state]="state"
      ></app-de-collective-invoice-success>

      <div *ngIf="backToMerchantPageUrl && !isWaitingForUpdate">
        <p *ngIf="noResponseMessage" class="no-response-message">
          {{ noResponseMessage }}
        </p>
        <zaver-secondary-button-outlined
          class="leave-button"
          [rounded]="true"
          (click)="leave(backToMerchantPageUrl)"
          [text]="'Weiter'"
        ></zaver-secondary-button-outlined>
      </div>
      <div *ngIf="isType('CHECKOUT') && isWaitingForUpdate">
        <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
      </div>

      <zaver-checkout-modal
        *ngIf="detailsMode"
        [buttonText]="'Schließen'"
        [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
        (onClose)="toggleModal()"
        [buttonText]="'Schließen'"
      >
        <app-selector *ngIf="!!selectorItems" [selectorItems]="selectorItems">
          <zaver-button-link [text]="'Allgemeine Zahlungsbedingungen'">
          </zaver-button-link
        ></app-selector>
      </zaver-checkout-modal>

      <div
        class="buttons-container"
        *ngIf="
          state.zaverProduct != 'TOKENIZED_ONBOARDING' &&
          state.zaverProduct != 'TOKENIZED_ONBOARDING_WITH_PAYMENT'
        "
      >
      <!-- TODO: Refactor to use actual button element. -->
        <div class="app-button" (click)="openTab(APP_STORE_LINK_DE)">
          <app-zaver-icon class="apple-logo" override="dark" [size]="16" name="appleLogo" ></app-zaver-icon>
          App Store
        </div>

        <div class="app-button" (click)="openTab(PLAY_STORE_LINK_DE)">
          <app-zaver-icon class="google-logo" override="dark" [size]="16" name="googleStore"></app-zaver-icon>
          Google Play
        </div>
      </div>
    </div>
  </div>
</div>
